import { Injectable, inject } from '@angular/core';
import { Functions, httpsCallable } from '@angular/fire/functions';

@Injectable({
  providedIn: 'root'
})
export class FunctionsService {

  private functions: Functions = inject(Functions);

  constructor() { }

  async callFunction(name: string, data: unknown) {
    try {
      return await httpsCallable(this.functions, name)(data);
    } catch (error) {
      const callableError = error as { code?: string; message?: string };
      console.error(`Firebase callable '${name}' failed`, {
        code: callableError.code,
        message: callableError.message
      });
      throw error;
    }
  }
}
